import React from "react";
import Plans from "../component/plan/Plans";
import SearchSection from "../component/search/SearchSection";
import AboutUs from "../component/aboutUs/AboutUs";
import { Helmet } from "react-helmet";

const HomePage =()=>{

    return(
        <div className="main_content">
            <Helmet>
            <link rel="canonical" href="/"/>
            <link rel="preload" href="https://fonts.gstatic.com/s/outfit/v14/QGYvz_MVcBeNP4NJtEtqUYLknw.woff2" as="font" type="font/woff2"
            crossorigin="anonymous"/>
            <link rel="preload"
            href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap"
            as="style" type="font/woff2" crossorigin="anonymous"/>
            <link rel="preload" href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap" as="style" type="font/woff2" crossorigin="anonymous"/>
            <link rel="preload" href="https://fonts.googleapis.com/css2?family=Fira+Sans+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Fjalla+One&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap"
            as="style" type="font/woff2" crossorigin="anonymous"/>
            <link rel="preload" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" as="style" onload="this.rel='stylesheet'"/>

            <title>Breakdowninc | Truck Repair,Semi Towing,Truck Tires,Truck Parts</title>
            <meta name="keywords" content="Truck Breakdown Services, Mobile Truck Repair, Semi Truck Repair Near Me,Trailer Repair Shops Emergency Roadside Assistance,Reefer Repair Services ,Heavy Duty Truck Towing ,Truck Tire Repair,Truck Mechanic Locator ,Commercial Vehicle Maintenance, Truck Driving Schools, Wrecker Services Near Me, Fleet Repair Solutions, 24/7 Truck Repair Help,
            Truck Service Directory Breakdown App for Truckers, Towing Services for Trucks, Truck Repair Network, Truck Maintenance Tips,Find Truck Repair Shops"/>
            <meta name="description" content="Breakdown Inc connects you to thousands of nearby places to get access to commercial truck parts, towing service, truck and trailer repair conveniences, and tire breakdown support—all fast and wherever and whenever you need it." />
            <meta property="og:title" content="Breakdowninc | Truck Repair,Semi Towing,Truck Tires,Truck Parts" />
            <meta property="og:description"
            content="Breakdown Inc connects you to thousands of nearby places to get access to commercial truck parts, towing service, truck and trailer repair conveniences, and tire breakdown support—all fast and wherever and whenever you need it." />
            </Helmet>

            <SearchSection/>
            <AboutUs/>
            <Plans/>
            <section className="about_section-2">
          <div className="container">
            <div className="row justify-content-center">
                    <div className="section-title col-md-12 mb-md-5 mb-4">
                       <p className="text-white font-weight-normal">- Get the Road Service -</p>
                       <h2 className="text-white">How Can We Help You?</h2>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Truck Repair Services</h2>
                    <p>Truck breakdowns are unpredictable, can occur anytime, anywhere. You can stay
                        prepared beforehand and find truck repair services near you with the help of the
                        Breakdown Inc app. Your one stop source to find affordable and quality truck
                        repair services.</p>
                    </div>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Trailer Repair Services</h2>
                    <p>Require trailer repair shop near you in an unknown location? Don't worry,
                        open Breakdown Inc. mobile app and find the nearest truck and <a href="https://breakdowninc.net/service-near-me/Trailer-Repair/Phoenix-AZ-USA"><b>trailer repair
                        near you</b></a> providers in seconds. Contact the service provider which suits you
                        the best, get service done & be back on the road in no time.</p>
                    </div>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Towing Services</h2>
                    <p>You can easily find your nearest tow truck service providers on
                        Breakdown Inc. mobile app, whether you are in need of heavy duty
                        vehicle towing or light duty vehicle towing. We take pride in
                        providing you with information that you can rely on.</p>
                    </div>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Reefer Repair</h2>
                    <p><a href="https://breakdowninc.net/plans"><b>Reefer repair near you</b></a>  is a relatively
                    rare service, and finding competent technicians can be challenging. But with Breakdown Inc. app,
                    you can easily locate reefer repair service providers near you. You can also find 24/7 Reefer repair
                    services on the Breakdown Inc app.</p>
                    </div>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Emergency Truck Repair​</h2>
                    <p>
                    An emergency can strike at any time, and it is undoubtedly quite stressful.
                    We recognize the importance of such situations, that's why we only provide
                    you with precise and dependable information on emergency truck maintenance
                    providers near you.
                    </p>
                    </div>
                    </div>

                    <div className="col-md-4 mb-4">
                    <div className="about_service h-100">
                    <h2>Tire Repair Service</h2>
                    <p>
                    Tire problems are the most common causes of breakdowns. Under-inflation, misaligned axles, and low
                    tread depth are the most common causes of tire failure. Whatever the situation may be, you can find
                    the <a href="https://breakdowninc.net/service-near-me/Towing-and-Recovery/Fresno-CA-USA"><b>tire repair service</b></a> near
                    me near you on Breakdown Inc mobile app.
                    </p>
                    </div>
                    </div>

         </div>
         </div>
        </section>
        </div>
    );
};

export default HomePage;